import { createSlice } from '@reduxjs/toolkit'

type initialProps = {
  dialogState: boolean
  dialogStateQr: boolean
  /** 外部アプリからQRを読み込んだ時の挙動 */
  stateQr: boolean
  dialogStateQrFinish: boolean
  dialogStateKey: boolean
  stateKeyWord: string
  dialogStatePoint: boolean
  dialogStateFarSpot: boolean
  dialogStateApply: boolean
  dialogStateApplyConfirm: boolean
  dialogStateApplyFinish: boolean
  dialogStateVisual: boolean
  dialogStampFinishState: boolean
  stampFinishState: boolean
  dialogStateCoupon: boolean
  dialogRegisterQuestionnaireState: boolean
  dialogStateAudio: boolean
}

const initialState: initialProps = {
  dialogState: false,
  dialogStateQr: false,
  stateQr: false,
  dialogStateQrFinish: false,
  dialogStateKey: false,
  stateKeyWord: '',
  dialogStatePoint: false,
  dialogStateFarSpot: false,
  dialogStateApply: false,
  dialogStateApplyConfirm: false,
  dialogStateApplyFinish: false,
  dialogStateVisual: false,
  dialogStampFinishState: false,
  stampFinishState: false,
  dialogStateCoupon: false,
  dialogRegisterQuestionnaireState: false,
  dialogStateAudio: false,
}

const dialogReducer = createSlice({
  name: 'dialog',
  initialState: initialState,
  reducers: {
    dialogState(state, action) {
      state.dialogState = action.payload
    },
    dialogStateQr(state, action) {
      state.dialogStateQr = action.payload
    },
    /** 外部アプリからQRを読み込んだ時の挙動 */
    stateQr(state, action) {
      state.stateQr = action.payload
    },
    dialogStateQrFinish(state, action) {
      state.dialogStateQrFinish = action.payload
    },
    dialogStateKey(state, action) {
      state.dialogStateKey = action.payload
    },
    stateKeyWord(state, action) {
      state.stateKeyWord = action.payload
    },
    dialogStatePoint(state, action) {
      state.dialogStatePoint = action.payload
    },
    dialogStateFarSpot(state, action) {
      state.dialogStateFarSpot = action.payload
    },
    dialogStateApply(state, action) {
      state.dialogStateApply = action.payload
    },
    dialogStateApplyConfirm(state, action) {
      state.dialogStateApplyConfirm = action.payload
    },
    dialogStateApplyFinish(state, action) {
      state.dialogStateApplyFinish = action.payload
    },
    dialogStateVisual(state, action) {
      state.dialogStateVisual = action.payload
    },
    dialogStampFinishState(state, action) {
      state.dialogStampFinishState = action.payload
    },
    stampFinishState(state, action) {
      state.stampFinishState = action.payload
    },
    dialogStateCoupon(state, action) {
      state.dialogStateCoupon = action.payload
    },
    dialogRegisterQuestionnaireState(state, action) {
      state.dialogRegisterQuestionnaireState = action.payload
    },
    dialogStateAudio(state, action) {
      state.dialogStateAudio = action.payload
    },
  },
})

export const {
  dialogState,
  dialogStateQr,
  stateQr,
  dialogStateQrFinish,
  dialogStateKey,
  stateKeyWord,
  dialogStatePoint,
  dialogStateFarSpot,
  dialogStateApply,
  dialogStateApplyConfirm,
  dialogStateApplyFinish,
  dialogStateVisual,
  dialogStampFinishState,
  stampFinishState,
  dialogStateCoupon,
  dialogRegisterQuestionnaireState,
  dialogStateAudio,
} = dialogReducer.actions

export default dialogReducer.reducer
